import { connect } from 'react-redux'
import { Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { bindActionCreators } from 'redux'

import { Modal } from '../../common-components'
import { goToManageLoginSession, logoutRequest } from 'quick-quote/actions'
import { logoutFromIDP } from 'identity/service'

/**
 * To display message if current login user has active login session more that expected sessions.
 * The modal wont't allow user to continue on futher steps but logging out.
 */
// TODO: Implement goToManageLoginSession() (if needed). This will allow user to login from other session/devices.
// TODO: This modal should block futher steps. So, onExit() should be removed?

const deviceType = {
  mobile: 'Mobile',
  browser: 'Web Browser'
}
export const _LoginLimitExceededPopup = ({ notificationMessage, logout, onExit, goToManageLoginSession, ...props }) => (
  <Modal
    isOpen={notificationMessage !== 'None'}
    backdrop={true}
    size="md"
    modalClassName="default-bootstrap login-session-limit-selling-modal"
  >
    <ModalHeader>จัดการอุปกรณ์</ModalHeader>
    <ModalBody>
      <p>
        ขณะนี้บัญชีของคุณใช้งานบน {deviceType[notificationMessage?.deviceType]}{' '}
        <strong>ครบ {notificationMessage?.numberOfLimit} เครื่องแล้ว</strong>
      </p>
      <p>โปรดออกจากระบบในอุปกรณ์ที่ไม่ได้ใช้งาน</p>
    </ModalBody>
    <ModalFooter>
      <div className="bottom">
        <Button
          color="outline-primary"
          onClick={() => {
            onExit()
            logout()
          }}
        >
          ออกจากระบบ
        </Button>
      </div>
    </ModalFooter>
  </Modal>
)

const mapDispatchToProps = (dispatch) => ({
  goToManageLoginSession: bindActionCreators(goToManageLoginSession, dispatch),
  logout: bindActionCreators(logoutRequest, dispatch),
})

export default connect(null, mapDispatchToProps)(_LoginLimitExceededPopup)
